var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2h3.648c.304 2.95 2.59 8.847 9.303 8.847 6.714 0 8.878-5.898 9.122-8.847h3.83c0 4.287-2.59 12.86-12.95 12.86C5.59 14.86 3 6.287 3 2zm25.72 19.61v-4.196H3.182v4.195H28.72zM19.052 5.191a3.1 3.1 0 1 1-6.202 0 3.1 3.1 0 0 1 6.202 0zM15.952 30a3.1 3.1 0 1 0 0-6.202 3.1 3.1 0 0 0 0 6.202z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdj);
export default __webpack_public_path__ + "static/media/USDJ.8ed05820a7f33ca3f4966b58c697744b.svg";
export { ForwardRef as ReactComponent };